var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-navigation-drawer",
    {
      attrs: {
        app: "",
        "expand-on-hover": "",
        clipped: "",
        "clipped-left": "",
      },
      scopedSlots: _vm._u([
        {
          key: "append",
          fn: function () {
            return [
              _c(
                "v-list",
                { attrs: { nav: "", dense: "" } },
                [
                  _c(
                    "v-list-item",
                    {
                      attrs: { link: "" },
                      on: {
                        click: function ($event) {
                          return _vm.app.logOut()
                        },
                      },
                    },
                    [
                      _c(
                        "v-list-item-icon",
                        [_c("v-icon", [_vm._v("mdi-logout")])],
                        1
                      ),
                      _c("v-list-item-title", [_vm._v("Log Out")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "v-list",
        { attrs: { nav: "", dense: "" } },
        [
          _c(
            "v-list-item",
            {
              attrs: { link: "" },
              on: {
                click: function ($event) {
                  return _vm.$router.push({ name: "Lists" })
                },
              },
            },
            [
              _c(
                "v-list-item-icon",
                [_c("v-icon", [_vm._v("mdi-view-list")])],
                1
              ),
              _c("v-list-item-title", [_vm._v("Lists")]),
            ],
            1
          ),
          _c(
            "v-list-item",
            {
              attrs: { link: "" },
              on: {
                click: function ($event) {
                  return _vm.$router.push({ name: "Settings" })
                },
              },
            },
            [
              _c("v-list-item-icon", [_c("v-icon", [_vm._v("mdi-cog")])], 1),
              _c("v-list-item-title", [_vm._v("Twilio Settings")]),
            ],
            1
          ),
          _c(
            "v-list-item",
            {
              attrs: { link: "" },
              on: {
                click: function ($event) {
                  return _vm.$router.push({ name: "phone_number_settings" })
                },
              },
            },
            [
              _c("v-list-item-icon", [_c("v-icon", [_vm._v("mdi-pound")])], 1),
              _c("v-list-item-title", [_vm._v("Phone Numbers")]),
            ],
            1
          ),
          _c(
            "v-list-item",
            {
              attrs: { link: "" },
              on: {
                click: function ($event) {
                  return _vm.$router.push({ name: "phone_settings" })
                },
              },
            },
            [
              _c("v-list-item-icon", [_c("v-icon", [_vm._v("mdi-phone")])], 1),
              _c("v-list-item-title", [_vm._v("Voice Settings")]),
            ],
            1
          ),
          _c(
            "v-list-item",
            {
              attrs: { link: "" },
              on: {
                click: function ($event) {
                  return _vm.$router.push({ name: "audio_files" })
                },
              },
            },
            [
              _c(
                "v-list-item-icon",
                [_c("v-icon", [_vm._v("mdi-volume-high")])],
                1
              ),
              _c("v-list-item-title", [_vm._v("Audio Files")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            value: this.lists.show_create_dialog,
            width: "500",
            persistent: "",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "text-h5 primary" }, [
                _vm._v(" Create a List "),
              ]),
              _c(
                "v-card-text",
                [
                  _c("p", { staticClass: "mt-8 mb-6" }, [
                    _vm._v("Enter a name for your new list below."),
                  ]),
                  _c("v-text-field", {
                    attrs: { outlined: "", label: "List Name" },
                    model: {
                      value: _vm.new_list.post_title,
                      callback: function ($$v) {
                        _vm.$set(_vm.new_list, "post_title", $$v)
                      },
                      expression: "new_list.post_title",
                    },
                  }),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.lists.show_create_dialog = false
                        },
                      },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        text: "",
                        loading: _vm.saving,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.createList()
                        },
                      },
                    },
                    [_vm._v(" Create ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }